import React, {Component} from 'react';
import { Spin, Table, Row, Button, Input, Divider, message } from 'antd';
import { RESTExecutor, withDomains } from '../../../lib/domain';
import { PopUpForm } from '../../../lib/ui/popupform';
import  Title  from 'antd/lib/typography/Title';
import { Link } from 'react-router-dom';
import ErrorWrapper from '../../../lib/error_wrapper';
import { showErrorInNotification, overrideHeaderTitle, overrideHeaderBack, NetworkDelaySearch, formatMoney } from '../../../lib/util';
import { BasicHeader } from '../../../components/basic_header';
import { TransparentButton } from '../../../components/basic_items';
import { CloudUploadOutlined } from '@material-ui/icons';

const queryString = require('query-string');

const pipeline_schema=[
    {
        index: "name",
        name: "Name",
        type: 'text'
    }, {
        index: 'description',
        name: "Description",
        type: 'textarea'
    }
];

const pipeline_cols = ({onEditPressed,datatype_id}) => [
    {
        title: "Name",
        dataIndex: "name",
        key: "name"
    }, {
        title: "Description",
        dataIndex: "description",
        key: 'description'
    }, {
        title: "Actions",
        dataIndex: 'id',
        key: 'action',
        width:100,
        render: (id, data) => {
            return <div style={{
                display:'flex',
                flexDirection:'row',
                alignItems:'center'
            }}>
                <Link to={`/settings/datatype/${datatype_id}/pipelines/${id}`}>
                    <Button style={{padding:0}} type='link'>View</Button>
                </Link>
                
            </div>
        }
    }
];
class DataPipelineList extends Component {
    constructor(props) {
        super(props)

        this.datatype_id = props.match.params.datatype_id;

        this.state = {
            filter_query:{
                per_page: 100,
                page: 1
            },

            form_data:{},
            form_visibility:false,

            upload_form_visibility:false
        }

        this.list_pipelines = RESTExecutor
        .list()
        .config({
            label: 'pipeline_list',
            params: {
                ...this.state.filter_query
            }
        }).forId(this.datatype_id)
        .callbacks((success)=>{},(error)=>{
            showErrorInNotification(error);
        })
        .connect(props.domains.datatype);

    this.post_pipeline=RESTExecutor.post().config({
        label:'pipeline_list'
    })
    .callbacks((success)=>{
        this.setState({
            form_visibility:false,
            edit_id:null,
            form_data:{}
        });
        this.props.history.push(`/settings/datatype/${this.datatype_id}/pipelines/${success.result.id}`)
        // this.list_pipelines.execute()
    })
    .connect(props.domains.datatype);

    this.patch_pipeline=RESTExecutor.patch().config({
        label:'pipeline_detail',
        params:{
            datatype_id:"",
            pipeline_id :""
        }
    })
    .callbacks((success)=>{
        this.setState({
            form_visibility:false,
            edit_id:null,
            form_data:{}
        });
        this.list_pipelines.execute()
    })
    .connect(props.domains.datatype);

    this.upload_data=RESTExecutor.post().config({
        label:'upload'
    }).callbacks((success)=>{
        message.success("File Uploaded")
        this.setState({
            upload_form_visibility:false
        })
    }).connect(props.domains.datatype);


    this.delay_search=new NetworkDelaySearch();

    // this.list_pipelines.execute()
    }

    handlePostPatch=(data)=>{
        if(this.state.edit_id){
            this.patch_pipeline.config({
                params:{
                datatype_id:this.datatype_id,
                pipeline_id :this.state.edit_id
                }
            }).execute(data);
        }else{
            this.post_pipeline.forId(this.datatype_id).execute(data);
        }
    }

    stateUpdater = ({
        stateKey,
        valueKey,
        value,
        appendObj = {},
        callback
    }) => {
        let newData = this.state[stateKey];
        this.has_changed = true;
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }

    render() {
        const {filter_query} = this.state;
        let list_pipelines_resp=this.list_pipelines.response();
        let post_pipeline_resp=this.post_pipeline.response();
        let patch_pipeline_resp=this.patch_pipeline.response();
        
        let upload_data_resp=this.upload_data.response();

        let rowsData=(list_pipelines_resp.result&&list_pipelines_resp.result.rows)||[];
        let rowsMeta=list_pipelines_resp.meta||{};

        return (
            <div>

<BasicHeader
          title="Pipelines"
          right={[
            <Link to={`/settings/datatype/${this.datatype_id}/pipelines/create`} >
            <TransparentButton
                label="Add New"
                hint="Add New Pipeline"
            />
        </Link>,
            <TransparentButton
              // className='cta-normal'
              label="Upload File"
              onClick={() => {
                this.setState({upload_form_visibility:true})
              }}
              icon={<CloudUploadOutlined className='btn-icon' />}
            />,
           ]}/>

            
<div className='filter-card'>
                    <div className='filter-card-top' style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        flexWrap: 'nowrap',
                    }}>
<Input.Search
                        autoFocus
                            placeholder="Search For"
                            style={{
                        }}
                            value={filter_query.query}
                            onChange={(e) => {
                            this.stateUpdater({stateKey: 'filter_query', valueKey: 'query', value: e.target.value,callback:()=>{
                                this.delay_search.onSearch(()=>{
                                    this.props.history.push({
                                        search:queryString.stringify({...this.state.filter_query,per_page:100,page:1})
                                    });
                            })
                            }})}}
                            /> 
                </div></div>
            <ErrorWrapper
            error={list_pipelines_resp}
            onReload={()=>{
                this.list_pipelines.forId(this.datatype_id).execute()
            }}
            >
            <div
                className='default-card'
                style={{
                padding: 0
            }}>
                <Table 
                    className='main-table' 
                    loading={list_pipelines_resp.fetching} 
                    size='small' 
                    scroll={{x:true}}
                    pagination={{
                        simple: false,
                        position:'bottom',
                    onChange: (current, size) => {
                        this.props.history.push({
                            // pathname:"users",
                            search:queryString.stringify({...this.state.filter_query,per_page:size,page:current})
                        })
                    },
                    defaultCurrent: 1,
                    current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                    pageSize: (rowsMeta && rowsMeta.requested_count),
                    total: (rowsMeta && rowsMeta.total_count),
                    showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                }}
                 rowKey={(record) => record.id} columns={pipeline_cols({
                    datatype_id:this.datatype_id,
                })} dataSource={rowsData}/>


            </div>
            </ErrorWrapper>
            <PopUpForm
                        title={"File Upload"}
                        stringyfy={false}
                        show_title_only
                        forCreate={true}
                        initialData={this.state.form_data}
                        fields={[
                            {index:'file',name:"File",type:'file',compress:true},
                            {index:'pipeline_id',type:'networkselect',name:"Pipeline",url:`/data-types/${this.datatype_id}/pipelines`},
                            {index:'closing_balance',name:"Closing Balance",type:'number'},
                            {index:'source_id',name:"Source",type:'text'}
                        ]}
                        open={this.state.upload_form_visibility}
                        networkState={upload_data_resp}
                        onClose={() => this.setState({upload_form_visibility: false,form_data:{}})}
                        onSubmit={(data) => {
                        console.log("DATA", data);
                        if(!data.file){
                            message.warn("Cannot upload empty data...");
                            return;
                        }else{
                            let _formdata=new FormData();
                            Object.keys(data).map((key)=>{
                                _formdata.append(key,data[key])
                            })
                        this.upload_data.forId(this.datatype_id).execute(_formdata);
                        }
                        // this.handlePostPatch(data);
                    }}/>
           
            </div>
        );
    }
    // componentDidMount(){
    //     // this.list_pipelines.execute()
    //     try{
    //         window.header_assigner.assignTitle("Pipeline List");
    
    //     }catch(e){}
    // }

    componentDidMount(){
        overrideHeaderTitle("Pipeline List");
        overrideHeaderBack('back');
        let new_filter_query={};
        if(this.props.location&&this.props.location.search){
        const parsed = queryString.parse(this.props.location.search);
        new_filter_query=parsed;
        }
        this.setState({
        filter_query:{
            per_page:100,
            page:1,
            ...new_filter_query
        }
        },()=>{
        this.list_pipelines.config({
            params: {
            ...this.state.filter_query
            }
        }).execute()
        })

    }
    componentWillUnmount(){
        overrideHeaderBack(null)
    }

    componentWillReceiveProps (nextProps) {
        var olddatatype_id = this.props.match.params.datatype_id;
        var newdatatype_id = nextProps.match.params.datatype_id;


        if(olddatatype_id!==newdatatype_id || (
          this.props.location&&(this.props.location.search!==nextProps.location.search)
        )){
            this.datatype_id=newdatatype_id;
            const parsed = queryString.parse(nextProps.location.search);
            this.setState({
                filter_query:{
                    per_page:100,
                    page:1,
                    ...parsed
                }
                },()=>{
                this.list_pipelines.forId(this.datatype_id).config({
                    params: {
                    ...this.state.filter_query
                    }
                }).execute()
                })
    
        }
    }

    // componentDidUpdate = (prevProps) => {
    //     if (this.props.match.params.datatype_id !== prevProps.match.params.datatype_id) {
    //         this.datatype_id = this.props.match.params.datatype_id;
    //         this.setState({loading: true})
    //         this.list_pipelines.forId(this.datatype_id).execute()
    //     };
    // };

}

export default withDomains(DataPipelineList,"datatype");
